exports.components = {
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-templates-markdown-page-jsx": () => import("./../../../src/templates/markdown-page.jsx" /* webpackChunkName: "component---src-templates-markdown-page-jsx" */)
}

